/**
 * 運賃条件の取得API store サービス
 *
 */
import { Injectable } from '@angular/core';
import {
  GetFareConditionsStore,
  resetGetFareConditions,
  selectGetFareConditionsState,
  setGetFareConditionsFromApi,
} from '@common/store/get-fare-conditions';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { FareConditionsRequest, DefaultService as ServicingApiService } from 'src/sdk-servicing';

/**
 * 運賃条件の取得API store サービス
 *
 * store情報
 */
@Injectable()
export class GetFareConditionsStoreService {
  constructor(private store: Store<GetFareConditionsStore>, private api: ServicingApiService) {}

  public getFareConditionsObservable() {
    return this.store.pipe(
      select(selectGetFareConditionsState),
      filter((data) => !!data)
    );
  }

  public resetGetFareConditions() {
    this.store.dispatch(resetGetFareConditions());
  }

  public setGetFareConditionsFromApi(request: FareConditionsRequest) {
    this.store.dispatch(
      setGetFareConditionsFromApi({
        call: this.api.fareConditionsPost(request),
      })
    );
  }
}
